<div id="data-model-prefs">
  <p-accordion >
    <p-accordion-panel value="'0'">
      <p-accordion-header>
        {{ "category_icon_update"| translation }}
      </p-accordion-header>
      <p-accordion-content>
        <cat-config></cat-config>
      </p-accordion-content>
    </p-accordion-panel>
    <p-accordion-panel value="'1'">
      <p-accordion-header>
        {{ "category_new"| translation }}
      </p-accordion-header>
      <p-accordion-content>
        <app-new-data-category></app-new-data-category>
      </p-accordion-content>
    </p-accordion-panel>
    <p-accordion-panel value="'2'">
      <p-accordion-header>
        {{ "data_type_update"| translation }}
      </p-accordion-header>
      <p-accordion-content>
        <app-type-config></app-type-config>
      </p-accordion-content>
    </p-accordion-panel>
    <p-accordion-panel value="'3'">
      <p-accordion-header>
        {{ "data_type_new"| translation }}
      </p-accordion-header>
      <p-accordion-content>
        <app-new-data-model></app-new-data-model>
      </p-accordion-content>
    </p-accordion-panel>
    <p-accordion-panel value="'4'">
      <p-accordion-header>
        {{ "configuration_updates"| translation }}
      </p-accordion-header>
      <p-accordion-content>
        <app-data-config-update></app-data-config-update>

      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
</div>
